import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';


@Component({
    selector: 'app-sales-history',
    templateUrl: './sales-history.component.html',
})

export class SalesHistoryComponent implements OnChanges {

    @Input() decimalPlaces : number = 0 ;
    @Input() qtyDecimal : number = 0 ;
    @Input() salesHistory;
    @Input() searchValueSales;
    @Input() noSalesFindOrLoadingText;
    @Input() totalRecordSales;
    @Input() module;

    displayAccountViewEdit : boolean = false;
    selectedAccountId: number;
    selectedAccountChannelId: number;

    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId  : number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule : string = "";
    @Output() getSalesHistory = new EventEmitter();

    pageNumber: number = 1;
    pageSize: number = 15;
    rowsPerPage = [15, 30, 50, 100];

    @Output() openLocationDialog = new EventEmitter<number>();
    constructor(
    ){ }

    ngOnInit(): void {
    }
    ngOnChanges(changes: SimpleChanges): void {
    }

    searchFilter(){
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValueSales}
        this.getSalesHistory.emit(obj);
    }
    onPageChange(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValueSales}
        this.getSalesHistory.emit(obj);
    }
    onRouteNavigation(str :string,e) {
        if(str == 'invoice'){
        this.inventoryOverviewRefId = e.invId;
        this.inventoryOverviewRefNumber = e.invoiceId;
        this.inventoryOverviewModule = "Invoice"
        this.displayInventoryOverview = true;
        }else if(str == 'account'){
        this.displayAccountViewEdit = true;
        this.selectedAccountChannelId = e.channelId;
        this.selectedAccountId = e.accountId ;
        }else if(str == 'location'){
        this.openLocationDialog.emit(e.warehouseId);
        }
    }
    closeViewPopup(){
            this.displayInventoryOverview = false;
    }

    closeAccountViewEditModal() {
        const obj ={pageNumber: this.pageNumber,pageSize: this.pageSize,value: this.searchValueSales}
        this.getSalesHistory.emit(obj);
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
    }
}



